const baseFieldPositions = {
  institute_name: { top: "1cm", left: "2cm" },
  branch_name: { top: "1.8cm", left: "2cm" },
  transaction_type: { top: "2.6cm", left: "2cm" },

  customer_name: { top: "4cm", left: "2cm" },
  customer_number: { top: "4.4cm", left: "2cm" },
  customer_address: { top: "0cm", left: "0cm" },
  branch_address: { top: "4.8cm", left: "2cm" },

  transaction_number: { top: "4cm", left: "14cm" },
  total_amount: { top: "4.8cm", left: "14cm" },
  date: { top: "5.6cm", left: "14cm" },
  print_time: { top: "6.4cm", left: "14cm" },

  // Invoice document fields (used by the Invoice print config)
  invoice_date: { top: "5.6cm", left: "2cm" },
  credit_period: { top: "4.8cm", left: "14cm" },
  note: { top: "8cm", left: "2cm" },

  // Reprint watermark — top-right corner, bold and prominent.
  // Rendered only when payload.reprint has a value (set when receipt_print > 0).
  reprint: { top: "0.3cm", left: "14cm", bold: true, font_size: "14px" },
} as const;

const fieldsWithDefaultVisibility = Object.fromEntries(
  Object.entries(baseFieldPositions).map(([key, value]) => [
    key,
    { ...value, visible: true },
  ])
);

export const defaultPrintConfig = {
  page: {
    width: "21cm",
    height: "29.7cm",
  },

  layout: {
    left_margin: "0cm",
    right_margin: "0.5cm",
  },

  sections: {
    table: {
      top: "7.5cm",
      left: "2cm",
      width: "15cm",
      row_height: "0.8cm",
      columns: ["account_number", "account_name", "amount"],
    },
  },

  fields: fieldsWithDefaultVisibility,
};
